import styles from '../DavidPifView.module.css'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

export function DavidGoliathSection() {
  const { t } = useTranslate('pif')

  return (
    <section className={classNames('relative w-full', styles['section-md'])} data-name="david-goliath">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#faf0e7]" />
        <Image
          alt=""
          className="object-cover opacity-[0.55] mix-blend-color-burn"
          src="/v1760914561/theatrical/david/dirt-texture-on-white-01"
          fill
          sizes="100vw"
          loading="lazy"
        />
      </div>
      <div
        className="relative mx-auto flex w-full max-w-[1440px] flex-col items-start gap-[40px] lg:flex-row lg:items-center lg:gap-[64px]"
        data-name="container-50-flip"
      >
        <div
          className={classNames(
            'relative mx-auto w-full grow-1 overflow-hidden rounded-3xl',
            styles['david-image-aspect-ratio'],
          )}
        >
          <Image
            loading="lazy"
            alt="David with his lamb"
            src="/v1763066693/theatrical/david/david-goliath-graphic.webp"
            fill
            className="object-cover"
          />
        </div>

        <div className="relative w-full">
          <div className="flex size-full flex-col justify-center">
            <div className="relative box-border flex w-full flex-col items-start justify-center gap-[32px] p-0 md:size-full md:gap-[40px]">
              <div className="relative flex w-full flex-col items-start gap-[12px] not-italic">
                <p className="font-angel-royal relative w-full text-5xl lowercase not-italic leading-[2.5rem] text-[#141447] md:text-[3.5rem] md:leading-[3rem]">
                  {t('davidGoliathMomentTitle', 'a True David & Goliath Moment')}
                </p>

                <div className="font-angelSans-medium relative flex w-full flex-col gap-6 text-[0px] leading-[0]">
                  <Text weight="medium" className="photon-paragraph-md md:photon-paragraph-lg">
                    <span className="italic">DAVID</span>
                    <span className="not-italic">
                      {t(
                        'davidGoliathParagraph1',
                        ' hits theaters December 19—the same week Avatar: Fire and Ash lands on screens nationwide. Just like the original story, this is a true underdog moment.',
                      )}
                    </span>
                  </Text>

                  <Text weight="medium" className="photon-paragraph-md md:photon-paragraph-lg">
                    <span className="fnot-italic">
                      {t(
                        'davidGoliathParagraph2Part1',
                        "By Paying it Forward, you're doing more than helping kids see ",
                      )}
                    </span>
                    <span className="italic">DAVID</span>
                    <span className="not-italic">
                      {t(
                        'davidGoliathParagraph2Part2',
                        " for free—you're also telling theaters that this story matters and deserves a place on screens across the country. Let's show the world that a story about courage, faith, and light can stand tall—no matter the giant.",
                      )}
                    </span>
                  </Text>
                </div>
              </div>
              <div
                className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[8px] md:w-auto md:flex-row"
                data-name="button-set"
              >
                <DavidButton variant="dark" openPifOverlay className="w-full md:w-auto">
                  {t('payItForward', 'Pay it Forward')}
                </DavidButton>
                <DavidButton variant="cyan" href="/tickets/david" className="w-full md:w-auto">
                  {t('getShowtimes', 'Get Showtimes')}
                </DavidButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
